<template>
  <div id="dropzone">
    <template v-for="(item, id) in trayData">
      <div
        :id="id"
        :style="[
          item.backgroundTileImage
            ? { backgroundImage: `url('${item.backgroundTileImage}')` }
            : { backgroundColor: item.hexColor },
          { backgroundColor: item.hexColor },
          {
            width:
              handleResize(
                item.tileWidth,
                item.tileHeight,
                item.productType
              ).width + 'px'
          },
          {
            height:
              handleResize(
                item.tileWidth,
                item.tileHeight,
                item.productType
              ).height + 'px'
          },
          { transform: `translate(${item.tileLeftOffset}px, ${item.tileTopOffset}px) ${item.isRotated ? 'rotate(90deg)' : 'rotate(0deg)'}` },
          { zIndex: item.imageZIndex },
          { backgroundSize: 'cover' }
        ]"
        :data-x="item.tileLeftOffset"
        :data-y="item.tileTopOffset"
        :data-r="item.isRotated ? '90' : '0'"
        class="draggable-card"
        :class="[selectedTile == id ? 'selected' : 'not-selected']"
        :data-inventoryType="item.inventoryType"
        @mousedown.left.prevent.stop="
          toggleSelectedTile(id);
          changeZIndex(id, '9999');
        "
        @touchstart="
          toggleSelectedTile(id);
          changeZIndex(id, '9999');
        "
      >
        <div class="tooltip text-capitalize" :class="[item.isRotated ? 'rotated' : '']">
          <template
            v-if="
              item.inventoryType == 'Resilient' ||
                item.inventoryType == 'Carpet'
            "
          >
          {{ item.sellingStyleName ? item.sellingStyleName :item.styleName }} {{ item.sellingStyleNumber }}<br />
            {{ item.colorName }} {{ item.colorNumber }}<br />
            {{ item.productTypeDesc ? item.productTypeDesc + "/" : ""
            }}{{ item.swatchWidth }}x{{ item.swatchLength }}<br />
          </template>
          <template v-if="item.inventoryType === 'Inspiration'">
            {{ item.colorName }} <br />
          </template>
          <template v-if="isPomInventoryType(item)">
            {{ $resourceString["virtualtray.pom"] }} {{ item.colorNumber }} <br />
          </template>

          <template v-if="item.inventoryType && item.inventoryType === 'Paint'">
            {{ $resourceString["virtualtray.paint"] }} {{ item.colorNumber }}
            {{ item.colorName }} <br />
          </template>
          {{ item.collection?item.collection:'' }}
        </div>
        <div
          class="remove"
          :class="[item.isRotated ? 'rotated' : '']"
          @mousedown.left.prevent.stop="$emit('trayDeleteItem', id)"
        >
          <Icon
            icon="bx:bx-x"
            height="1.5em"
            class="remove"
            aria-hidden="true"
          />
        </div>
        <div
          v-if="
            item.inventoryType == 'Carpet' || item.inventoryType == 'Resilient'
          "
          class="rotate"
          :class="[item.isRotated ? 'rotated' : '']"
          @mousedown.left.prevent.stop="
            [toggleSelectedTile(''), swapHeightWidth(item)]
          "
        >
          <Icon icon="dashicons:image-rotate" :vertical-flip="true" />
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { Icon } from "@iconify/vue2";

export default {
  components: {
    Icon
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions({
      toggleSelectedTile: "virtualTray/toggleSelectedTile",
      loadTray: "virtualTray/loadTray"
    }),
    isPomInventoryType(item) {
      return item.inventoryType
        ? item.inventoryType.toUpperCase() === "POM"
        : false;
    },
    swapHeightWidth(item) {
      item.isRotated = !item.isRotated;
      document.getElementById(item.id)?.click();
      document.getElementById(item.id)?.click();
    },
    changeZIndex(id, value) {
      document.getElementById(id).style.zIndex = value;
    },
    handleResize(w, h, productType) {
      if (productType?.toLowerCase() == "broadloom") {
        var newWidth = w;
        var newHeight = h;
        var maxWidth = 250; // Default
        var maxHeight = 250; // Default
        const windowWidth = window.innerWidth;

        if (windowWidth >= 768 && windowWidth <= 1024) {
          // Tablet
          maxWidth = 200;
          maxHeight = 200;
        } else if (windowWidth < 768) {
          // Mobile
          maxWidth = 100;
          maxHeight = 100;
        }

        if (maxWidth < w || maxHeight < h) {
          newWidth = maxWidth;
          newHeight = maxHeight;

          if (w > maxWidth) {
            newHeight = (h * maxWidth) / w;
          } else {
            newWidth = (w * maxHeight) / h;
          }
        } else {
          if (maxWidth / 2 > w || maxHeight / 2 > h) {
            newWidth = maxWidth / 2;
            newHeight = maxHeight / 2;

            if (w < maxWidth / 2) {
              newHeight = (h * maxWidth) / 2 / w;
            } else {
              newWidth = (w * maxHeight) / 2 / h;
            }
          }
        }

        return { width: newWidth, height: newHeight };
      } else {
        return { width: w, height: h };
      }
    },
    getNewZIndex() {
      const max = Math.max(...Object.values(this.trayData).map(item => item.imageZIndex))
      return (max > -1) ? max + 1 : 0;
    },
    updateTrayData(){
      const target = document.querySelectorAll(".draggable-card.selected")[0];
      if(target)
      {
        let tileData = this.trayData[target?.getAttribute('id')];
        tileData.tileLeftOffset = (parseFloat(target?.getAttribute('data-x')) || 0);
        tileData.tileTopOffset = (parseFloat(target?.getAttribute('data-y')) || 0);
        tileData.imageZIndex = this.getNewZIndex();
      }
    },
  },
  computed: {
    ...mapGetters({
      trayData: "virtualTray/trayData",
      trayOrders: "virtualTray/trayOrders",
      selectedTile: "virtualTray/selectedTile"
    })
  },
  mounted() {
    window.addEventListener("mouseup", this.updateTrayData);
  }
};
</script>
